<div class="notes-tab">
  <!-- Search and Filters -->
  <div class="notes-header">
    <div class="row" style="margin-right: -10px">
      <div class="col-md-2">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="searchText"
          (ngModelChange)="filterNotes()"
          placeholder="Search notes..."
          aria-label="Search driver notes"
        />
      </div>
      <div class="col-md-2">
        <select class="form-control" [(ngModel)]="filterDriver" (ngModelChange)="filterNotes()" aria-label="Filter by driver">
          <option value="">All Drivers</option>
          <option *ngFor="let d of drivers" [value]="d.id">{{ d.name }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <select class="form-control" [(ngModel)]="filterStatus" (ngModelChange)="filterNotes()" aria-label="Filter by status">
          <option value="">All Statuses</option>
          <option value="Open">Open</option>
          <option value="Resolved">Resolved</option>
        </select>
      </div>
      <div class="col-md-2">
        <select class="form-control" [(ngModel)]="filterType" (ngModelChange)="filterNotes()" aria-label="Filter by note type">
          <option value="">All Types</option>
          <option *ngFor="let type of noteTypes" [value]="type">{{ type }}</option>
        </select>
      </div>
      <div class="col-md-2">
        <input
          type="date"
          class="form-control"
          [(ngModel)]="filterDateFrom"
          (ngModelChange)="filterNotes()"
          placeholder="From date"
          title="From date"
          aria-label="Filter from date"
        />
      </div>
      <div class="col-md-2">
        <input
          type="date"
          class="form-control"
          [(ngModel)]="filterDateTo"
          (ngModelChange)="filterNotes()"
          placeholder="To date"
          title="To date"
          aria-label="Filter to date"
        />
      </div>
    </div>
  </div>

  <!-- Note Cards (shared component) -->
  <app-driver-note-cards
    [notes]="filteredNotes"
    [searchText]="searchText"
    [canEdit]="false"
    [showDriverInfo]="true"
    [loading]="loading"
    [pageSize]="pageSize"
    (viewNote)="viewNote($event)"
  ></app-driver-note-cards>
</div>

<!-- View Note Modal (shared component, read-only) -->
<app-driver-note-form-modal
  [(visible)]="showViewModal"
  [note]="selectedNote"
  [readOnly]="true"
  [hideEmailButtons]="true"
  (closed)="closeViewModal()"
></app-driver-note-form-modal>
